var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasrafiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,5.3V0H0v5.3h1.8v8.8H0v5.3h1.8V30h26.5V19.4H30v-5.3h-1.8V5.3H30z M1.8,1.8h26.5v1.8H1.8V1.8z M12.3,5.3h5.4V7h-5.4 L12.3,5.3z M26.5,28.2h-23v-8.8h7v3.5h8.9v-3.5h7V28.2z M12.3,19.4h5.4v1.8h-5.4L12.3,19.4z M28.2,17.6H1.8v-1.8h26.5L28.2,17.6z  M26.5,14.1h-23V5.3h7v3.5h8.9V5.3h7L26.5,14.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasrafiIcon);
export default __webpack_public_path__ + "static/media/masrafiIcon.4d0f52b280760cb712d777abc94cf6bb.svg";
export { ForwardRef as ReactComponent };